export const MODE_LABELS = {
  progressive: "One line per ready agent",
  predictive: "Paced by answer rate",
}

export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]

export const POD_TIMEZONES = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "Pacific/Honolulu",
]

export function formatWeekdays(days) {
  return (days || []).map((day) => WEEKDAYS[day]).join(", ")
}

export function formatTime(value) {
  return (value || "").slice(0, 5)
}

export function clientLabel(client) {
  return client?.name ? `${client.name} (${client.email})` : client?.email || ""
}

/**
 * One row per active campaign. Labelled with just the client name unless the
 * client runs several campaigns, so single-campaign clients look as before.
 */
export function campaignRows(pod) {
  return (pod.clients || [])
    .filter((podClient) => podClient.active)
    .flatMap((podClient) => {
      const campaigns = podClient.campaigns || []
      const name = podClient.client?.name || podClient.client?.email || ""
      return campaigns.map((campaign) => ({
        podClient,
        campaign,
        label: campaigns.length > 1 ? `${name} — ${campaign.name}` : name,
      }))
    })
}
